import { persistentAtom } from "@nanostores/persistent";
import { deserialize, serialize } from "wagmi";
import { LocalStorageKeys } from "./keys";
import type { ClaimParams, ManualClaimParams } from "./types";

export const $manualClaimTxHistoryAtom = persistentAtom<ClaimParams[]>(LocalStorageKeys.MANUAL_CLAIM_TX_HIST_KEY, [], {
  encode: serialize,
  decode: deserialize,
});

export function getManualClaimTxHistory(): ClaimParams[] {
  return $manualClaimTxHistoryAtom.get();
}

export function storeManualClaimTx(claimData: ManualClaimParams) {
  const history = $manualClaimTxHistoryAtom.get();
  const data = history.concat({ ...claimData, id: crypto.randomUUID() });
  $manualClaimTxHistoryAtom.set(data);
}
